module.exports = __webpack_public_path__ + "static/media/news__001.d8b3c2e8.jpg";